import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox/';
import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';

import { BULK_UPDATE_FULFILLMENT_PLAN_ID } from '../../../constants';
import style from '../inputs.module.css';
import { messages } from '../messages';

/**
 * @param {object} props
 * @param {boolean} [props.checked]
 * @param {string} [props.fulfillmentPlanId]
 * @param {string} props.label
 * @param {string} [props.optionData]
 * @param {() => void} [props.onCheck]
 * @param {(newChange: {id: string, value: string}) => void} [props.updateOption]
 * @returns {React.JSX.Element}
 */

export const FedExBookingConfirmation = ({
  checked = false,
  label,
  onCheck = noop,
  optionData = '',
  updateOption = noop,
  fulfillmentPlanId = '',
}) => {
  const [value, setValue] = useState(optionData);

  useEffect(() => {
    if (!checked) {
      setValue('');
    } else if (fulfillmentPlanId === BULK_UPDATE_FULFILLMENT_PLAN_ID) {
      setValue('');
    }
  }, [fulfillmentPlanId, checked]);

  const onBlur = useCallback(() => {
    updateOption({ id: 'fedExBookingConfirmation', value });
  }, [value, updateOption]);

  return (
    <div>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {checked ? (
        <div className={style['single-input']}>
          <Input label={<FormattedMessage {...messages.bookingLabel} />} onBlur={onBlur} onChange={setValue} value={value} />
        </div>
      ) : null}
    </div>
  );
};
